export const EMPTY_CONTACT = { contact_name: "", phone: "", email: "" };

export const validateContact = (c) => {
  if (!c.contact_name.trim()) return "Please add your full name.";
  if (!c.phone.trim()) return "Please add your mobile number.";
  if (!c.email.trim()) return "Please add your email address.";
  return null;
};

export const trimContact = (c) => ({
  contact_name: c.contact_name.trim(),
  phone: c.phone.trim(),
  email: c.email.trim(),
});

const inputCls =
  "mt-1.5 w-full rounded-sm border border-white/10 bg-obsidian-700 p-3.5 text-sm text-white placeholder:text-zinc-600 outline-none focus:border-neon transition-colors";

export const ContactFields = ({ form, set, testid, compact = false }) => (
  <div className={compact ? "space-y-3" : "grid gap-4 md:grid-cols-3"}>
    <label className="block">
      <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500">Full name</span>
      <input value={form.contact_name} onChange={set("contact_name")} placeholder="Full name" autoComplete="name" required
             className={inputCls} data-testid={`${testid}-name`} />
    </label>
    <label className="block">
      <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500">Mobile number</span>
      <input type="tel" value={form.phone} onChange={set("phone")} placeholder="04.." autoComplete="tel" inputMode="tel" required
             className={inputCls} data-testid={`${testid}-phone`} />
    </label>
    <label className="block">
      <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500">Email address</span>
      <input type="email" value={form.email} onChange={set("email")} placeholder="you@email.com" autoComplete="email" inputMode="email" required
             className={inputCls} data-testid={`${testid}-email`} />
    </label>
  </div>
);
